module.exports = __webpack_public_path__ + "32cfacd4c70e8efeb64051d1d09807a5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/flask-green.png
// module id = 2839
// module chunks = 0